import React, { useEffect, useState } from "react";
import { Box, Typography, Grid, CircularProgress } from "@mui/material";
import { FormattedMessage } from "react-intl";
import { useParcelsMawb } from "../../../services/clear-customs/mawb";

const customsProcessing = "Customs processing";
const customsDone = "Customs done";

const status = {
  EMPTY: customsProcessing,
  PROCESSING: customsProcessing,
  PROCESSED: customsDone,
  NOT_DECLARED: customsProcessing,
  DECLARED: customsDone
};

export function MAWBInfoCard({ id }) {
  const { fetchMawbParcelsData, mawbInfoCard } = useParcelsMawb();
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setIsLoading(true);
    fetchMawbParcelsData({ id, onFinally });
  }, [id]);

  function onFinally() {
    setIsLoading(false);
  }

  if (isLoading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" py={6}>
        <CircularProgress size={30} />
      </Box>
    );
  }

  return (
    <Box
      sx={{
        backgroundColor: "var(--container-light)",
        borderRadius: 2,
        p: 3,
        boxShadow: "0px 2px 10px rgba(0,0,0,0.05)",
        margin: "0 2.8rem 0 0"
      }}
    >
      <Typography
        variant="h6"
        fontWeight={700}
        fontSize={20}
        color="var(--button-subtle-text)"
        mb={2}
        data-testid={`mawb_number`}
      >
        MAWB {mawbInfoCard?.mawbNumber}
      </Typography>

      <Grid
        container spacing={6}
        data-testid={`mawb_info_box`}
      >
        <Grid item xs={12} sm={4}>
          <Typography fontWeight={600} fontSize={14} color="var(--button-subtle-text)"
            data-testid={`total_number_of_parcels`}
          >
            <FormattedMessage id="totalNumberOfParcels" />
          </Typography>
          <Typography
            data-testid={`number_of_parcels`}
            fontSize={14} color="var(--font-medium-default)">
            {mawbInfoCard?.numberOfParcels?.toLocaleString("de-DE") ?? "-"}
          </Typography>

          <Typography
            data-testid={`departure`}
            fontSize={14} fontWeight={600} color="var(--button-subtle-text)" mt={2}>
            <FormattedMessage id="departure" />
          </Typography>
          <Typography
            data-testid={`departureAirport`}
            fontSize={14} color="var(--font-medium-default)">
            {mawbInfoCard?.departureAirport || "-"}
          </Typography>
        </Grid>

        <Grid item xs={12} sm={4}>
          <Typography
            data-testid={`overall_gross_weight`}
            fontSize={14} fontWeight={600} color="var(--button-subtle-text)">
            <FormattedMessage id="overallGrossWeight" />
          </Typography>
          <Typography
            data-testid={`total_gross_weight`}
            fontSize={14} color="var(--font-medium-default)">
            {mawbInfoCard?.totalGrossWeight != null ? (
              `${Number(mawbInfoCard?.totalGrossWeight)?.toLocaleString?.("de-DE", {
                minimumFractionDigits: 2
              })} kg`
            ) : (
              "-"
            )}
          </Typography>
          <Typography
            data-testid={`destination`}
            fontSize={14} fontWeight={600} color="var(--button-subtle-text)" mt={2}>
            <FormattedMessage id="destination" />
          </Typography>
          <Typography
            data-testid={`destination_airport`}
            fontSize={14} color="var(--font-medium-default)">
            {mawbInfoCard?.destinationAirport || "-"}
          </Typography>
        </Grid>

        <Grid item xs={12} sm={4}>
          <Typography
            data-testid={`total_value_heading`}
            fontSize={14} fontWeight={600} color="var(--button-subtle-text)">
            <FormattedMessage id="totalValue" />
          </Typography>
          <Typography
            data-testid="total_value"
            fontSize={14}
            color="var(--font-medium-default)"
          >
            {mawbInfoCard?.totalValue != null
              ? `${mawbInfoCard?.totalValue?.toLocaleString?.("de-DE", {
                minimumFractionDigits: 2
              })} EUR`
              : "-"}

          </Typography>


          <Typography
            data-testid={`overall-status_heading`}
            fontSize={14} fontWeight={600} color="var(--button-subtle-text)" mt={2}>
            <FormattedMessage id="overallStatus" />
          </Typography>
          <Typography
            data-testid={`overall-status`}
            fontSize={14} color="var(--font-medium-default)">
            {status[mawbInfoCard?.overallStatus] || "-"}
          </Typography>
        </Grid>
      </Grid>
    </Box>
  );
}
